import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Estimate from "@/pages/Estimate";
import Book from "@/pages/Book";
import Success from "@/pages/Success";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import LeadDetail from "@/pages/admin/LeadDetail";
import AdminSettings from "@/pages/admin/Settings";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import { captureFromLocation } from "@/lib/source";

function SourceCapture() {
  const location = useLocation();
  useEffect(() => {
    // Only inspects query params — no-ops when there aren't any ref/utm keys.
    captureFromLocation(location);
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <SourceCapture />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/estimate" element={<Estimate />} />
            <Route path="/book" element={<Book />} />
            <Route path="/success" element={<Success />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/leads/:id"
              element={
                <ProtectedRoute>
                  <LeadDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute>
                  <AdminSettings />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
